// extracted by mini-css-extract-plugin
export default {"content":"index-module--content--ZXwgT","logo":"index-module--logo--3sd7s","nav":"index-module--nav--t4h-1"};